import i18n from 'i18next';
import { siteRegion } from './core/config';
import translationRu from './assets/locales/ru/translation.json';
import translationUz from './assets/locales/uz/translation.json';


i18n.init({
  lng: siteRegion,
  fallbackLng: siteRegion,
  supportedLngs: ['ru', 'uz'],
  debug: true,
  resources: {
    ru: {translation: translationRu},
    uz: {translation: translationUz},
  },
  preload: true,
});
console.log('i18n loaded:', i18n.services.resourceStore.data);

export default i18n;
